import { Injectable, Inject } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionAttribute, DwExpressionCompareType, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService,
         DwOrmDataService, DwOrmDataServiceToken, DwMetaDataService, DwMetaDataServiceToken, DwLookupInfo } from '@devwareapps/devware-cap';
import { CodeValuePermitType, Permits2PermitEntity, PermitsV2MetaDataItemNames, PermitsV2MetaDataLookups } from '../meta-data/permitsv2-meta-data.service';

@DwCustomContextDefinition({
    keyName: 'permitV2PermitTypesContext',
    display: 'Permit V2 - Permit Types',
    isGlobal: false,
    parentItem: PermitsV2MetaDataItemNames.Permits2Permit
})
@Injectable()
export class PermitV2PermitTypeContextService extends DwCustomContextBase {
    levelLookupItems: DwLookupInfo[];

    constructor(
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService
    ){
        super();
        this.dwMetaDataService.getLookup(PermitsV2MetaDataLookups.CodeValuePermitType)
        .subscribe(levelLookupItems => {
            this.levelLookupItems = levelLookupItems;
        });
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            const permit: Permits2PermitEntity = resolvedContext?.data;
            const permitTypeCvs =  permit?.Permits2PermitPermitType?.filter(pt => !pt._isDeleted).map(pt => pt.PermitTypeCv) || [];

            const accessControl : number = permit?.Permits2AccessControl?.length;
            const dataVoice : number = permit?.Permits2RequiredCable?.
                                               filter(f => f.PermitTypeCv == CodeValuePermitType.DataVoice).length;
            const cctv : number = permit?.Permits2RequiredCable?.
                                               filter(f => f.PermitTypeCv == CodeValuePermitType.CCTV).length;
            const audioVisual : number = permit?.Permits2RequiredCable?.
                                               filter(f => f.PermitTypeCv == CodeValuePermitType.AudioVisual).length;

            // if (!this.levelLookupItems){
            //     this.dwMetaDataService.getLookup(PermitsV2MetaDataLookups.CodeValuePermitType)
            //     .subscribe(levelLookupItems => {
            //         this.levelLookupItems = levelLookupItems;
            //     });
            // }
            const typesDisplay: string = 
                this.levelLookupItems ? this.levelLookupItems.filter(l => permitTypeCvs.includes(+l.Id)).map(i => ' ' + i.Display).toString()
                                      : null;
            return { 
                PermitTypes : permitTypeCvs,
                PermitTypesDisplay: typesDisplay,
                PermitTypesCount : permitTypeCvs.length,
                AccessControlCount: accessControl || 0,
                DataVoiceCableCount: dataVoice || 0,
                CCTVCableCount: cctv || 0,
                AudioVisualCableCount: audioVisual || 0
            };
        });

        contextDef.attributes = [];
        var hasPermissionAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
                                                                        'PermitTypes', 'Permit Types', 
                                                                         DwAttributeType.Integer, DwControlType.DropDownList);
        
        hasPermissionAttr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains, DwExpressionCompareType.inList, DwExpressionCompareType.notInList];
        hasPermissionAttr.Attribute.IsLookup = true;
        hasPermissionAttr.Attribute.MetaDataLookupId = PermitsV2MetaDataLookups.CodeValuePermitType;
        var permitTypesCountAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
            'PermitTypesCount', 'Permit Types Count', DwAttributeType.Integer, DwControlType.NumericTextBox);
        var permitTypesDisplayAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
            'PermitTypesDisplay', 'Permit Types Display', DwAttributeType.Text, DwControlType.Textbox);

        var accessControlAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
            'AccessControlCount', 'Access Control Count', DwAttributeType.Integer, DwControlType.NumericTextBox);
        var dataVoiceAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
            'DataVoiceCableCount', 'Data/Voice Cable Count', DwAttributeType.Integer, DwControlType.NumericTextBox);
        var cctvAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
            'CCTVCableCount', 'CCTV Cable Count', DwAttributeType.Integer, DwControlType.NumericTextBox);
        var audioVisualAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
            'AudioVisualCableCount', 'Audio/Visual Cable Count', DwAttributeType.Integer, DwControlType.NumericTextBox);
                        
    }

}
